import React, { useState } from 'react'
import './contact.scss'
import { httpOperations, clientUrl } from '../../services/httpOperations'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
export const Contact = () => {
  const [name, setName] = useState();
  const [email, setEmail] = useState();
  const [subject, setSubject] = useState();
  const [message, setMessage] = useState();

  const handleSubmit = () => {
    const payload = {
      contactInfo: {
        name,
        email,
        subject,
        message
      }

    }
    httpOperations.http_post(clientUrl + "contact", payload)
      .then((res) => {
        if (res.status === 201) {
          toast.success("Thank you!", { autoClose: 2000 })
          setName("");
          setEmail("");
          setSubject("");
          setMessage("");
        } else {
          toast.error("Something went wrong. Please email your info at rathishudhay@gmail.com")
        }

      })
  }

  return (

    <section class="contact" id="contact">
      <ToastContainer />
      <div class="max-width">
        <h2 class="title">Contact me</h2>
        <div class="contact-content">
          <div class="column left">
            <div class="text">
              Get in Touch
            </div>
            <p>If you feel that I can do the work as expected, then please contact me using below details.. </p>
            <div class="icons">
              <div class="row">
                <i class="fas fa-user"></i>
                <div class="info">
                  <div class="head">Name</div>
                  <div class="sub-title">Rathish Kumar</div>
                </div>
              </div>
              <div class="row">
                <i class="fas fa-map-marker-alt"></i>
                <div class="info">
                  <div class="head">Address</div>
                  <div class="sub-title">Chennai, India</div>
                </div>
              </div>
              <div class="row">
                <i class="fas fa-envelope"></i>
                <div class="info">
                  <div class="head">Email</div>
                  <div class="sub-title">rathishudhay@gmail.com</div>
                </div>
              </div>
            </div>

          </div>
          <div class="column right">
            <div class="text">
              Message me
            </div>
            <div className="message-input-container">
              <input
                onChange={(e) => setName(e.target.value)}
                value={name}
                placeholder="Name" className="messageInput halfWidth" type="text" />
              <input
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                placeHolder="Email" className="messageInput halfWidth" type="text" />
              <input
                onChange={(e) => setSubject(e.target.value)}
                value={subject}
                placeHolder="Subject" className="messageInput fullWidth" type="text" />
              <textarea
                onChange={(e) => setMessage(e.target.value)}
                value={message}
                placeHolder="Message" className="messageInput fullWidth" />
              <button onClick={handleSubmit} className="submitButton">Submit</button>
            </div>
          </div>
        </div>

      </div>
    </section>
  )
}
